module.exports = __webpack_public_path__ + "static/pic01-58f0d56a9ed66f3bf06fef48c0e52dbc.jpg";